import React from 'react';
import { createRoot } from 'react-dom/client';
import './styles/App.scss';
import App from './App';
import * as pwa from './utils/pwa';

import './utils/fontawesome';

const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register PWA service worker
pwa.register({
  onSuccess: (registration) => {
    console.log('Service worker registration successful');
  },
  onUpdate: (registration) => {
    console.log('New content is available; please refresh.');
    // You can show an update notification here
  }
});

// Initialize PWA install prompt
pwa.initInstallPrompt();

// Initialize network status monitoring
pwa.initNetworkStatus();
